<template>
  <section class="s-cons" aria-labelledby="insurance-consult-title">
    <header class="s-cons__header">
      <h2 id="insurance-consult-title" class="wd-title">
        <span class="s-cons__base">Consulta el avance <br class="br-m" />de</span> <span class="hl">tu solicitud</span>
      </h2>
      <p class="wd-body">
        Selecciona una opción <br class="br-m" />para conocer los requisitos <br class="br-m" />y pasos que debes
        seguir.
      </p>
    </header>

    <form class="s-cons__fields" @submit.prevent="submit(contractNumber, claimFile)">
      <label class="s-cons__field">
        <span class="s-cons__label">Número de contrato</span>
        <span class="s-cons__input">
          <img :src="boltIcon" alt="" aria-hidden="true" />
          <input
            v-model="contractNumber"
            type="text"
            required
            maxlength="80"
            autocomplete="off"
            placeholder="Ingresa número de contrato"
          />
          <img :src="arrowIcon" alt="" aria-hidden="true" />
        </span>
      </label>

      <label class="s-cons__field">
        <span class="s-cons__label">Folio del siniestro</span>
        <span class="s-cons__input">
          <img :src="boltIcon" alt="" aria-hidden="true" />
          <input
            v-model="claimFile"
            type="text"
            required
            maxlength="80"
            autocomplete="off"
            placeholder="Ingresa folio del siniestro"
          />
          <img :src="arrowIcon" alt="" aria-hidden="true" />
        </span>
      </label>
      <button type="submit" class="s-cons__button" :disabled="state === 'loading'">
        {{ state === 'loading' ? 'Consultando…' : 'Consultar estatus' }}
      </button>
    </form>
    <div class="s-cons__feedback" aria-live="polite" :aria-busy="state === 'loading'">
      <p v-if="state === 'unavailable'">
        La consulta por contrato y folio aún no está disponible.
        <router-link :to="{ name: 'cliente-cliente-siniestro-generales' }"
          >Ingresa al portal para consultar tus siniestros.</router-link
        >
      </p>
      <p v-if="state === 'invalid'">Escribe tu número de contrato y folio del siniestro.</p>
      <p v-if="state === 'empty'">No encontramos una solicitud con esos datos. Revisa tu contrato y folio.</p>
      <p v-if="state === 'error'" role="alert">No pudimos consultar tu solicitud. Inténtalo de nuevo.</p>
      <p v-if="state === 'success' && result">
        <strong>{{ result.status }}</strong> {{ result.description }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useInsuranceClaimLookup, type InsuranceClaimLookup } from '../composables/useInsuranceClaimLookup'
const props = defineProps<{ lookup?: InsuranceClaimLookup }>()
const { state, result, submit, reset } = useInsuranceClaimLookup(() => props.lookup)

import boltIcon from '../../../assets/seguros-figma/input-bolt.svg'
import arrowIcon from '../../../assets/seguros-figma/input-arrow.svg'

const contractNumber = ref('')
const claimFile = ref('')
watch([contractNumber, claimFile], reset)
</script>

<style scoped>
.s-cons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ds-space-4);
  padding: var(--ds-space-5);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}

.s-cons__header {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  width: 100%;
}
.s-cons__base {
  color: var(--ds-purple-900);
}

.s-cons__fields {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  width: 100%;
}
.s-cons__field {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
}
.s-cons__label {
  color: var(--ds-purple-900);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.s-cons__input {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  height: 48px;
  padding: 0 var(--ds-space-4);
  box-sizing: border-box;
  border: 1px solid #666c78;
  border-radius: 4px;
  background: var(--ds-grey-50);
}
.s-cons__input img {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
}
.s-cons__input input {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--ds-text-body);
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  line-height: 24px;
}
.s-cons__input input::placeholder {
  color: #666c78;
}
.s-cons__input:focus-within {
  border-color: var(--ds-purple-500);
}

.s-cons__button {
  width: 340px;
  max-width: 100%;
  height: 48px;
  padding: 10px var(--ds-space-4);
  box-sizing: border-box;
  border: 1px solid var(--ds-purple-500);
  border-radius: 24px;
  background: var(--ds-grey-50);
  color: var(--ds-purple-500);
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
}

@media (max-width: 599px) {
  .s-cons {
    padding: var(--ds-space-4);
  }
  .s-cons__button {
    width: 100%;
  }
}
.s-cons__feedback {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
}
.s-cons__feedback p {
  margin: 0;
}
.s-cons__button:disabled {
  cursor: wait;
  opacity: 0.65;
}
</style>
